/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const checkIsValueWithinRange = (
  value: string,
  compareFirst: string,
  compareSecond: string
) => {
  if (
    Number(value) >= Number(compareFirst) !==
    Number(value) <= Number(compareSecond)
  )
    return false;

  return true;
};
